import type { Translations } from './pt-BR';

const fr: Translations = {
  nav: {
    dashboard:    'Accueil',
    forecast:     'Prévision',
    birthChart:   'Thème Natal',
    synastry:     'Synastrie',
    questions:    'Demander aux Astres',
    astromatch:   'AstroMatch',
    tarot:        'Tarot de Marseille',
    lenormand:    'Cartomancie Gitane',
    numerology:   'Numérologie',
    iChing:       'I Ching',
    dreamJournal: 'Journal des Rêves',
    moonPhases:   'Phases de la Lune',
    agenda:       'Agenda Astrologique',
    retrograde:   'Radar Rétrograde',
    eclipses:     'Eclipse Insight',
    astroPet:     'Astro Pet',
    astroCoach:   'Astro Coach',
    startAstral:  'Rota Profissional',
    empresas:     'Entreprises',
    astrocartografia:    'Astrocartografia',
    wallet:         'Portefeuille',
    readings:       'Lectures',
    settings:       'Paramètres',
    signOut:        'Se déconnecter',
    quiromancy:     'Chiromancie',
    vedicAstrology: 'Astrologie Védique',
    humanDesign:    'Human Design',
    blog:           'Blog',
    pricing:        'Offres',
  },
  credits: {
    questions:  'Crédits de questions',
    synastry:   'Crédits de synastrie',
    astromatch: 'Crédits AstroMatch',
  },
  home: {
    heroBadge:       'Personnalisé pour vous. Pas pour votre signe.',
    heroHeadline1:   'Secret',
    heroHeadline2:   'Astral.',
    heroSubheadline: 'Astrologie, tarot, I Ching, numérologie et plus, révélés spécifiquement pour vous.',
    heroCta1:        'Découvrez votre Secret Astral →',
    heroCta2:        'Voir les prévisions du jour',
    heroSocialProof: '✦ Plus de 50 000 lectures réalisées',
    heroScrollHint:  'Voir les prévisions par signe',

    signForecastTitle:    'Prévision du jour',
    signForecastSubtitle: 'Sélectionnez votre signe et consultez ce que les astres vous réservent aujourd\'hui.',
    forecastToday:        'Prévision d\'aujourd\'hui',
    forecastWeek:         'Prévision de cette semaine',
    forecastMonth:        'Prévision de ce mois',
    consultingStars:      'Consultation des astres pour {sign}...',
    starsMoving:          'Les astres sont en mouvement. Réessayez dans un instant ✦',
    seeFullForecast:      'Voir la prévision complète ✦',

    featureTitle:    'Tout ce dont vous avez besoin, en un seul endroit',
    featureSubtitle: 'Des prévisions quotidiennes au thème natal complet, 3 000 ans de tradition à portée de main.',
    startFree:       'Commencer gratuitement ✦',

    feat: {
      birthChartTitle:    'Thème Natal',
      birthChartDesc:     'Découvrez vos planètes, maisons et aspects avec une interprétation complète en français.',
      birthChartBadge:    'Premium',
      forecastTitle:      'Prévision Personnalisée',
      forecastDesc:       'Prévisions quotidiennes, hebdomadaires et mensuelles calculées pour votre thème natal.',
      synastryTitle:      'Synastrie',
      synastryDesc:       'Comparez votre thème avec celui d\'une personne spéciale et voyez la compatibilité complète.',
      synastryBadge:      'Premium',
      questionsTitle:     'Demander aux Astres',
      questionsDesc:      'Posez n\'importe quelle question et recevez une réponse astrologique personnalisée.',
      astromatchTitle:    'AstroMatch',
      astromatchDesc:     'Envoyez une photo et découvrez la personnalité astrologique par la physiognomonie.',
      astromatchBadge:    'Exclusif',
      moreTitle:          'Tarot, I Ching et plus',
      moreDesc:           'Tirage de Tarot, I Ching, Numérologie, Journal des Rêves et Phases de la Lune.',
    },

    premiumBadge:   '✦ Plan Premium',
    premiumTitle1:  'Plongez au cœur',
    premiumTitle2:  'de vos astres',
    premiumDesc:    'Avec Professya Premium, vous accédez au thème natal complet, à la synastrie illimitée, aux prévisions personnalisées et bien plus, pour moins d\'1 € par jour.',
    premiumF1:      'Thème natal complet avec interprétation',
    premiumF2:      'Prévisions quotidiennes, hebdomadaires et mensuelles',
    premiumF3:      'Synastrie relationnelle',
    premiumF4:      'Questions illimitées aux astres',
    premiumF5:      'AstroMatch par photo',
    premiumF6:      'Accès au Tarot, I Ching et Numérologie',
    premiumPrice:   '4,99 €',
    premiumPer:     '/mois',
    premiumCta:     'S\'abonner maintenant ✦',
    premiumCancel:  'Résiliez quand vous voulez. Sans engagement.',

    demoLabel1: 'Thème Natal',
    demoSub1:   'Soleil en Bélier · Lune en Taureau · ASC Gémeaux',
    demoLabel2: 'Synastrie',
    demoSub2:   'Compatibilité 87% ✦ Vénus en harmonie',
    demoLabel3: 'Prévision d\'aujourd\'hui',
    demoSub3:   '"Vénus favorise les connexions profondes..."',

    servicesTitle:    'Nos Services',
    servicesSubtitle: 'Des prévisions quotidiennes au thème natal complet, tout pour votre connaissance de soi astrologique.',
    servicesCta:      'Accéder à tous les services ✦',
    badgePlan:        'Abonnement',
    badgeCredits:     'Crédits',
    badgeAvulso:      'À la carte',
    badgeNew:         'Nouveau ✦',
    svc: {
      birthChart:  { name: 'Thème Natal',              subtitle: 'Votre thème natal complet',                        description: 'Découvrez la position exacte de toutes les planètes, maisons et aspects au moment de votre naissance. Ce n\'est pas un horoscope générique, c\'est la carte unique que vous seul possédez.' },
      forecast:    { name: 'Prévision Personnalisée',   subtitle: 'Quotidienne, hebdomadaire, mensuelle et annuelle',  description: 'Prévisions calculées pour VOTRE thème natal, pas pour votre signe. Sachez exactement quelles planètes activent votre vie maintenant et ce qui vous attend dans les prochains mois.' },
      synastry:    { name: 'Synastrie',                 subtitle: 'Compatibilité profonde entre deux thèmes',          description: 'Analysez la connexion réelle entre deux thèmes natals. Découvrez les aspects qui créent attraction, tension, mission karmique et potentiel à long terme dans toute relation.' },
      astroMatch:  { name: 'AstroMatch',                subtitle: 'Compatibilité avant la première rencontre',         description: 'Indiquez le prénom, le signe et quelques caractéristiques de quelqu\'un et découvrez le potentiel astrologique de cette connexion avant de vous engager. Économisez du temps et de l\'énergie.' },
      astrocartografia: { name: 'Astrocartografia',              subtitle: 'Où dans le monde vous prospérez',                   description: 'Comparez votre thème natal avec celui de 195 pays et découvrez où vous avez le plus de potentiel en amour, carrière, santé et qualité de vie. Analyse aussi toute ville spécifique.' },
      questions:   { name: 'Demander aux Astres',       subtitle: 'Réponses directes de l\'oracle',                    description: 'Posez n\'importe quelle question et recevez une réponse personnalisée basée sur les transits planétaires actifs dans votre thème natal en ce moment précis.' },
      tarot:       { name: 'Tarot de Marseille',         subtitle: '4 types de tirage interprétés',                     description: 'Tirages de 1, 3, 7 et 10 cartes avec une interprétation profonde ancrée dans la tradition du Tarot de Marseille, combinée à la position de vos planètes au moment de la consultation.' },
      lenormand:   { name: 'Oracle Lenormand',           subtitle: 'L\'oracle gitan des 36 cartes',                      description: 'L\'oracle Lenormand révèle les patterns cachés de votre vie à travers ses 36 cartes. Choisissez parmi des tirages de 1, 3, 5 ou 9 cartes pour une lecture personnalisée.' },
      numerology:  { name: 'Numérologie',               subtitle: 'Les chiffres qui régissent votre vie',              description: 'Nombre du Destin, Âme, Personnalité et Année Personnelle calculés à partir de votre nom complet et date de naissance. Découvrez les cycles qui gouvernent votre voyage.' },
      astroPet:    { name: 'Astro Pet',                 subtitle: 'Le thème natal de votre animal',                    description: 'Calculez le thème natal de votre animal de compagnie et découvrez sa personnalité astrologique. Analysez aussi la compatibilité entre vous et votre animal.' },
      startAstral: { name: 'Rota Profissional',              subtitle: 'Votre vocation par le thème natal',                 description: 'Analyse complète de votre Milieu du Ciel, Saturne, Jupiter et Nœud Nord pour révéler votre vocation, vos talents naturels et le chemin professionnel le plus aligné avec qui vous êtes.' },
      retrograde:  { name: 'Radar Rétrograde',          subtitle: 'Impact réel sur votre thème',                       description: 'Sachez exactement comment Mercure, Vénus, Mars et autres planètes rétrogrades affectent VOTRE thème natal, pas une prévision générique par signe.' },
      eclipse:     { name: 'Eclipse Insight',           subtitle: 'Éclipses qui activent votre vie',                   description: 'Découvrez quelles maisons et planètes de votre thème natal sont activées par les éclipses solaires et lunaires, et ce que cela signifie pour les 6 prochains mois de votre vie.' },
    },
  },
  auth: {
    email:            'E-mail',
    password:         'Mot de passe',
    confirmPassword:  'Confirmer le mot de passe',
    signIn:           'Se connecter',
    createAccount:    'Créer un compte',
    forgotPassword:   'Mot de passe oublié',
    resetPassword:    'Réinitialiser le mot de passe',
    noAccount:        'Pas encore de compte ?',
    hasAccount:       'Déjà un compte ?',
    orContinue:       'ou continuer avec',
    sendReset:        'Envoyer le lien de réinitialisation',
    backToLogin:      'Retour à la connexion',
    checkEmail:       'Vérifiez votre e-mail pour le lien de réinitialisation.',
    signInTitle:      'Connectez-vous à votre compte',
    createTitle:      'Créez votre compte gratuit',
    name:             'Prénom',
    namePlaceholder:  'Votre prénom',
    showPassword:     'Afficher le mot de passe',
    hidePassword:     'Masquer le mot de passe',
    createFree:       'Créer un compte gratuit',
    createCta:        'Créer un compte ✦',
    agreeText:        'En créant un compte vous acceptez nos',
    terms:            'Conditions',
    privacyPolicy:    'Politique de confidentialité',
    biometricTitle:   '✦ Voulez-vous vous connecter plus vite ?',
    biometricDesc:    'Activez Face ID / Touch ID pour accéder à Professya sans saisir votre mot de passe.',
    biometricEnable:  'Activer Face ID / Touch ID',
    biometricSkip:    'Pas maintenant',
    continueGoogle:   'Continuer avec Google',
    continueApple:    'Continuer avec Apple',
    oauthError:       'Erreur d\'authentification. Réessayez.',
  },
  common: {
    loading:      'Chargement...',
    error:        'Erreur',
    retry:        'Réessayer',
    save:         'Enregistrer',
    cancel:       'Annuler',
    back:         'Retour',
    close:        'Fermer',
    confirm:      'Confirmer',
    language:     'Langue',
  },
  dashboard: {
    cosmicBrief:       '✦ Bref Cosmique',
    consultingStars:   'Consultation des astres pour vous...',
    starsMoving:       'Les astres sont en mouvement. Votre bref cosmique sera prêt dans un instant ✦',
    completeBanner:    '✦ Complétez votre profil',
    completeBannerSub: 'Ajoutez votre date de naissance pour des lectures personnalisées.',
    addData:           'Ajouter des données',
    quickAccess:       'Accès rapide',
    continueJourney:   'Continuez votre voyage',
    seeAll:            'Voir tout',
    greetingMorning:   'Bonjour',
    greetingAfternoon: 'Bon après-midi',
    greetingEvening:   'Bonsoir',
    errorTitle:        'Quelque chose s\'est mal passé',
    errorSubtitle:     'Nous n\'avons pas pu charger votre profil. Essayez de rafraîchir la page.',
    reload:            'Actualiser',
    suggBirthChartDesc: 'Découvrez vos planètes et maisons astrologiques.',
    suggForecastTitle:  'Prévision de la semaine',
    suggForecastDesc:   'Ce que les astres vous réservent cette semaine.',
    suggQuestionsDesc:  'Posez votre première question avec 1 crédit gratuit.',
    premiumBadge:        'Premium actif ✦',
    premiumWelcomeTitle: 'Bienvenue sur Professya Premium !',
    premiumWelcomeDesc:  'Explorez vos premières fonctionnalités.',
    premiumClose:        'Fermer',
    premiumStep1:        'Thème Natal',
    premiumStep2:        'Prévision',
    premiumStep3:        'Synastrie',
    premiumStep4:        'AstroMatch',
    premiumStep5:        'Tarot',
    renewalTitle:        'Votre abonnement expire {when}',
    renewalToday:        'aujourd\'hui',
    renewalTomorrow:     'demain',
    renewalDays:         'dans {days} jours',
    renewalDesc:         'Renouvelez maintenant pour ne pas perdre l\'accès Premium.',
    renewalCta:          'Renouveler ✦',
    tierPremium:         'Premium',
    streakSingular:      'jour consécutif',
    streakPlural:        'jours consécutifs',
    creditQuestionsSingular: 'question',
    creditQuestionsPlural:   'questions',
    creditSynastry:          'synastrie',
  },
  layout: {
    navSigns:      'Signes',
    navBlog:       'Blog',
    navPlans:      'Abonnements',
    navMyAccount:  'Mon compte',
    navSignIn:     'Se connecter',
    navStartFree:  'Commencer gratis',
    footerTagline: 'Astrologie et ésotérisme pour votre quotidien.',
    footerProduct: 'Produit',
    footerLegal:   'Légal',
    footerRights:  'Tous droits réservés.',
    footerMotto:   'Secret Astral',
    footerSignos:  'Signes',
    footerBirthChart: 'Thème Natal',
    footerSynastry:   'Synastrie',
    footerQuestions:  'Questions',
    footerPrivacy:    'Confidentialité',
    footerTerms:      'Conditions d\'utilisation',
    footerLgpd:       'Politique des données',
    footerBrandTagline:  'Professya, Votre connaissance de soi révélée par les astres, le tarot, l\'I Ching et bien plus encore.',
    footerServices:      'Services',
    footerOracles:       'Oracles',
    footerForecast:      'Prévision',
    footerAstroMatch:    'AstroMatch',
    footerAstrocartografia:   'Astrocartografia',
    footerStartAstral:   'Rota Profissional',
    footerTarot:         'Tarot',
    footerIChing:        'I Ching',
    footerNumerology:    'Numérologie',
    footerAstroPet:      'Astro Pet',
    footerPrivacyFull:   'Politique de confidentialité',
    footerTermsFull:     'Conditions d\'utilisation',
    footerLgpdFull:      'Politique des données',
    footerCancellation:  'Résiliation',
    footerBusiness:      'Pour les Entreprises',
    footerContact:       'Contact',
    footerCopyright:     '© {year} Professya. Tous droits réservés.',
    footerDisclaimer:    'Les lectures ont un caractère réflexif et de divertissement. ✦',
    footerNewsletterDesc: 'Actualités astrologiques dans votre email. Sans spam.',
  },
  forecast: {
    title:          'Prévision',
    emptyTitle:     'Date de naissance requise',
    emptySubtitle:  'Ajoutez votre date de naissance pour recevoir des prévisions personnalisées.',
    emptyCta:       'Ajouter des données',
    starsMoving:    'Les astres sont en mouvement. Réessayez dans un instant ✦',
    periodToday:    'Aujourd\'hui',
    periodWeek:     'Cette semaine',
    periodMonth:    'Ce mois',
    periodYear:     'Cette année',
    loadingDaily:   'Consultation des astres du jour...',
    loadingWeekly:  'Calcul de la semaine astrologique...',
    loadingMonthly: 'Analyse du mois dans les astres...',
    loadingAnnual:  'Préparation de votre prévision annuelle...',
    skyNow:              'Ciel Maintenant',
    transitShort:        'Aujourd\'hui & Cette Semaine',
    transitMedium:       'Actif Depuis Plus de 30 Jours',
    transitMediumBadge:  'Moyen terme',
    transitLong:         'Transformations de Fond',
    transitLongBadge:    'Long terme',
    transitApproaching:  '↗ En approche',
    transitPeak:         '◉ Au pic',
    transitSeparating:   '↘ En séparation',
    transitLongTermChip: '⟳ Long terme',
    transitRetrograde:   '® Rétrograde',
    illumination:        'illumination',
    regenerateTitle:     'Générer une nouvelle prévision',
    regenerateCta:       '↺ Régénérer',
    stillThinking:       'Les astres révèlent encore... ✦',
  },
  tabs: {
    home:      'Accueil',
    forecast:  'Prévision',
    questions: 'Demander',
    match:     'Match',
    wallet:    'Portefeuille',
    ariaLabel: 'Navigation principale',
    map:       'Carte',
    atlas:     'Local',
    profile:   'Profil',
    search:    'Rechercher',
    today:     'Aujourd\'hui',
    me:        'Moi',
  },
  pages: {
    onboarding: {
      stepOf: 'Étape {step} sur {total}',
      welcomeTitle: 'Bonjour, {name} !',
      welcomeText: 'Bienvenue sur Professya, votre espace d\'astrologie et d\'ésotérisme.\nPréparons votre expérience personnalisée en quelques étapes.',
      welcomeCta: 'Commencer ✦',
      birthDataTitle: 'Vos données de naissance',
      birthDataDesc: 'Nécessaires pour calculer votre thème natal. L\'heure est optionnelle mais améliore la précision.',
      birthDateLabel: 'Date de naissance',
      birthTimeLabel: 'Heure de naissance',
      birthCityLabel: 'Ville de naissance',
      optional: '(optionnel)',
      youAreSign: 'Vous êtes {sign} !',
      backBtn: 'Retour',
      continueBtn: 'Continuer',
      skipNow: 'Passer pour l\'instant',
      skipSetup: 'Passer la configuration →',
      firstReadingTitle: 'Votre première lecture',
      firstReadingDesc: 'En tant que {sign}, les astres ont beaucoup à vous dire.',
      firstReadingDesc2: 'Avec vos données complètes, les astres peuvent vous parler directement.',
      previewLabel: 'Aperçu de votre tableau de bord :',
      previewFeat1Label: 'Prévision du jour',
      previewFeat1Desc: 'Calculée pour votre thème natal',
      previewFeat2Label: 'Thème Natal',
      previewFeat2Desc: 'Soleil, Lune, Ascendant et 8 autres planètes',
      previewFeat3Label: 'Demandez aux Astres',
      previewFeat3Desc: '1 question gratuite pour les nouveaux comptes',
      viewDashboard: 'Voir mon tableau de bord',
      upgradeTitle: 'Approfondissez votre voyage',
      upgradeDesc: 'Avec Premium, débloquez le thème natal complet, la synastrie, les prévisions personnalisées et bien plus, pour moins d\'1 € par jour.',
      upgradeF1: 'Thème natal complet',
      upgradeF2: 'Synastrie relationnelle',
      upgradeF3: 'Prévisions quotidiennes personnalisées',
      upgradeF4: 'Questions illimitées aux astres',
      upgradeF5: 'AstroMatch par photo',
      upgradeCta: 'S\'abonner au Premium ✦',
      upgradeFreeCta: 'Continuer avec le compte gratuit →',
    },
    birthChart: {
      title: 'Thème Natal',
      houseSystem: 'Calcul Précis',
      howToRead: 'Comment lire mon thème',
      calculating: 'Calcul de vos planètes et maisons astrologiques...',
      planetPositions: 'Positions Planétaires',
      planet: 'Planète', sign: 'Signe', degree: 'Degré', house: 'Maison',
      showAll: 'Voir toutes les planètes ({n} de plus)',
      showLess: 'Afficher moins',
      interpretation: 'Interprétation ✦',
      calculateCta: 'Calculer mon thème natal',
      retry: '↺ Réessayer',
      starsMoving: 'Les astres sont en mouvement intense. Réessayez dans un instant ✦',
      emptyTitle: 'Date de naissance requise',
      emptySubtitle: 'Pour calculer votre thème natal, nous avons besoin de votre date de naissance. Ajoutez-la dans Profil.',
      emptyCta: 'Aller au Profil',
      guideTitle: 'Comment lire votre thème',
      guideCta: 'Compris ✦',
    },
    synastry: {
      title: 'Compatibilité Astrologique',
      subtitle: 'Synastrie',
      partnerDataTitle: 'Données du partenaire',
      partnerNameLabel: 'Prénom',
      partnerNamePlaceholder: 'Prénom de la personne',
      partnerSignLabel: 'Signe solaire',
      selectSign: 'Sélectionnez le signe',
      partnerDateLabel: 'Date de naissance',
      autoAnalyzeHint: 'L\'analyse démarre automatiquement une fois ce champ rempli',
      analyzeCta: 'Analyser la compatibilité (1 crédit)',
      inviteText: 'Vous préférez que l\'autre personne remplisse ses propres données ?',
      generateLink: 'Générer un lien d\'invitation via WhatsApp',
      linkGenerated: 'Lien généré :',
      copyBtn: 'Copier',
      compatibility: 'Compatibilité',
      noCreditsMsg: 'Vous n\'avez pas de crédits de synastrie.',
      buyLink: 'Acheter →',
      calculating: 'Calcul de la synastrie entre {partner} et {user}...',
      newAnalysis: 'Nouvelle synastrie',
      errorMsg: 'Analyse de synastrie temporairement indisponible. Réessayez ✦',
      emptyTitle: 'Date de naissance requise',
      emptySubtitle: 'Ajoutez votre date de naissance pour faire une synastrie.',
      emptyCta: 'Aller au Profil',
      tabScore: 'Score', tabAnalise: 'Analyse', tabAspectos: 'Aspects',
      tabCasas: 'Maisons', tabComposto: 'Composite', tabDavison: 'Davison',
      tabTransitos: 'Transits', tabProgressoes: 'Progressions',
      scoreLove: 'Amour & Chimie', scoreCommunication: 'Communication', scoreValues: 'Valeurs',
      scoreLongTerm: 'Long terme', scoreGrowth: 'Croissance', scoreRoutine: 'Routine', scoreFamily: 'Famille',
    },
    tarot: {
      title: 'Tarot de Marseille',
      subtitle: 'Tradition classique des Arcanes Majeurs et Mineurs',
      restart: 'Recommencer',
      intentionMsg: 'Concentrez-vous sur une question...',
      loading: 'Les arcanes se mettent en place...',
      generalReading: '✦ Lecture Générale',
      reversed: 'Renversée',
      spreadSingle: 'Carte du Jour',
      spreadSingleDesc: '1 carte, focus et énergie du moment',
      spreadThree: 'Passé · Présent · Futur',
      spreadThreeDesc: '3 cartes, ligne du temps',
      spreadHorseshoe: 'Fer à cheval',
      spreadHorseshoeDesc: '7 cartes, vue d\'ensemble de la situation',
      spreadCeltic: 'Croix Celtique',
      spreadCelticDesc: '10 cartes, analyse approfondie',
    },
    lenormand: {
      title: 'Oracle Lenormand',
      subtitle: 'L\'oracle gitan des 36 cartes',
      restart: 'Nouvelle lecture',
      intentionMsg: 'Respirez profondément et concentrez-vous sur votre question...',
      loading: 'Les cartes gitanes se révèlent...',
      readingTitle: '✦ Votre Lecture',
      subscriptionRequired: 'Cette consultation est disponible pour les abonnés mensuels ou annuels.',
      spreadSingle: 'Carte du Moment',
      spreadSingleDesc: '1 carte, le message essentiel',
      spreadThree: 'Ligne du Temps',
      spreadThreeDesc: '3 cartes, passé, présent et chemin',
      spreadFive: 'Croix',
      spreadFiveDesc: '5 cartes, situation et conseil',
      spreadNine: 'Carré',
      spreadNineDesc: '9 cartes, lecture complète',
      questionLabel: 'Votre question (optionnelle)',
      questionPlaceholder: 'Que souhaitez-vous comprendre ? Laissez vide pour une lecture générale.',
      questionCta: 'Révéler les cartes ✦',
    },
    questions: {
      title: 'Demandez aux Astres',
      questionLabel: 'Votre question',
      questionPlaceholder: 'Écrivez votre question pour les astres...',
      showExamples: 'Voir des exemples de questions',
      hideExamples: 'Masquer les exemples',
      disclaimer: 'Réponses à caractère réflexif · Consultez des professionnels pour des décisions importantes',
      submitCta: 'Demander (1 crédit)',
      submitLoading: 'Consultation des astres...',
      answerTitle: '✦ Les astres répondent',
      historyTitle: 'Historique des questions',
      noCreditsTitle: 'Vous n\'avez pas assez de crédits. Voulez-vous en acheter ?',
      noCreditsDesc: 'Vos crédits sont épuisés. Choisissez un forfait ci-dessous pour continuer.',
      loading: 'Les astres considèrent votre question...',
      emptyTitle: 'Complétez votre profil d\'abord',
      emptySubtitle: 'Ajoutez votre date de naissance pour poser des questions personnalisées aux astres.',
      emptyCta: 'Aller au Profil',
    },
    numerology: {
      title: 'Numérologie',
      subtitle: 'Les nombres qui régissent votre parcours',
      intro: 'Calculez votre carte numérologique complète basée sur votre nom et date de naissance.',
      calculateCta: 'Calculer ma numérologie ✦',
      calculating: 'Les nombres sont en cours de calcul...',
      lifePathLabel: 'Chemin de Vie',
      destinyLabel: 'Destin',
      soulLabel: 'Âme',
      personalityLabel: 'Personnalité',
      newConsult: 'Nouvelle consultation',
      error: 'Les nombres sont en alignement. Réessayez dans un instant ✦',
      emptyTitle: 'Données requises',
      emptySubtitle: 'Ajoutez votre nom et date de naissance dans votre profil pour calculer votre numérologie.',
      emptyCta: 'Aller au Profil',
      tabSinteseGeral: 'Synthèse Générale', tabCaminhoDeVida: 'Chemin de Vie',
      tabDestino: 'Nombre du Destin', tabAlma: 'Nombre de l\'Âme', tabPersonalidade: 'Personnalité',
    },
    iching: {
      title: 'I Ching',
      subtitle: 'Le Livre des Mutations',
      intro: 'Le I Ching consulte les patterns de mutation de l\'univers pour révéler l\'essence de votre situation.',
      questionLabel: 'Votre question',
      questionPlaceholder: 'Que souhaitez-vous comprendre ?',
      throwingCoins: 'Lancement des pièces...',
      consultCta: 'Consulter l\'oracle ✦',
      throwingMsg: 'Lancement des pièces sacrées...',
      interpretingMsg: 'L\'oracle interprète les mutations...',
      hexagramLabel: 'Hexagramme {n}, {name}',
      transformsInto: 'Se transforme en : Hexagramme {n}',
      newConsult: 'Nouvelle consultation',
      error: 'L\'oracle est silencieux. Réessayez dans un instant ✦',
    },
    dreamJournal: {
      title: 'Journal des Rêves',
      subtitle: 'Découvrez les messages de l\'inconscient',
      dreamLabel: 'Décrivez votre rêve',
      dreamPlaceholder: 'Décrivez en détail ce que vous avez rêvé... Personnes, lieux, sensations, couleurs...',
      interpretCta: 'Interpréter mon rêve ✦',
      loading: 'Plongée dans les couches de l\'inconscient...',
      symbolsTitle: '✦ Symboles identifiés',
      interpretationTitle: '✦ Interprétation',
      guidanceTitle: '✦ Orientation',
      historyTitle: 'Journal',
      newEntry: 'Enregistrer un autre rêve',
      error: 'L\'inconscient est silencieux. Réessayez dans un instant ✦',
    },
    moonPhases: {
      title: 'Phases de la Lune',
      subtitle: 'Calendrier lunaire et énergies du cycle',
      illuminated: '{n}% illuminée',
      upcomingPhases: '✦ Prochaines phases',
      ritualsFor: '✦ Rituels pour {phase}',
    },
    humanDesign: {
      title: 'Human Design',
      subtitle: 'Votre type et stratégie de vie',
      intro: 'Découvrez votre type de Human Design, stratégie de vie et autorité intérieure pour prendre des décisions avec clarté.',
      calculateCta: 'Calculer mon Human Design ✦',
      calculating: 'Calcul de votre Human Design...',
      birthTimeWarning: '✦ Heure de naissance recommandée',
      birthTimeWarningDesc: 'Le Human Design est plus précis avec votre heure de naissance. Sans elle, nous utiliserons un calcul approximatif.',
      addBirthTime: 'Ajouter l\'heure de naissance →',
      profileLabel: 'Profil',
      authorityLabel: 'Autorité',
      strategyLabel: 'Stratégie',
      signatureLabel: 'Signature',
      notSelfLabel: 'Non-Soi',
      centersTitle: '✦ Centres',
      recalculate: 'Recalculer',
      error: 'Le système Human Design est en analyse. Réessayez dans un instant ✦',
      emptyTitle: 'Date de naissance requise',
      emptySubtitle: 'Ajoutez votre date de naissance pour calculer votre Human Design.',
      emptyCta: 'Aller au Profil',
    },
    vedicAstrology: {
      title: 'Astrologie Védique',
      subtitle: 'Jyotish, la Science de la Lumière',
      intro: 'L\'astrologie védique (Jyotish) est un système millénaire indien utilisant le zodiaque sidéral, révélant des couches profondes du destin, du karma et du but.',
      consultCta: 'Consulter Jyotish ✦',
      loading: 'Calcul du thème védique...',
      addBirthTime: '✦ Ajouter votre heure de naissance rend la lecture beaucoup plus précise.',
      keyPositions: '✦ Positions clés',
      ascLabel: 'Ascendant (Lagna)',
      moonLabel: 'Signe de la Lune',
      sunLabel: 'Signe du Soleil',
      nakshatraLabel: 'Nakshatra',
      dashaLabel: 'Dasha actuel',
      yogasLabel: 'Yogas présents',
      newConsult: 'Nouvelle consultation',
      error: 'Les astres védiques sont en alignement. Réessayez dans un instant ✦',
      emptyTitle: 'Date de naissance requise',
      emptySubtitle: 'Ajoutez votre date de naissance pour accéder à l\'astrologie védique.',
      emptyCta: 'Aller au Profil',
    },
    astromatch: {
      title: 'AstroMatch',
      subtitle: 'Analyse astrologique par physiognomie',
      subjectNameLabel: 'Prénom de la personne',
      subjectNameOptional: '(optionnel)',
      subjectNamePlaceholder: 'Ex : Jean',
      cameraBtn: 'Caméra / Galerie',
      noConsent: '↑ Acceptez les conditions ci-dessus pour activer l\'envoi de photo',
      newAnalysis: 'Nouvelle analyse',
      errorMsg: 'Nous n\'avons pas pu traiter l\'analyse. Réessayez ✦',
      errorRetry: 'Essayer avec une autre photo',
      loading1: 'Analyse des traits du visage...',
      loading2: 'Consultation des astres...',
      loading3: 'Calcul du thème natal...',
      loading4: 'Préparation de votre analyse ✦',
    },
    quiromancy: {
      title: 'Chiromancie',
      subtitle: 'Lecture des lignes de la main',
      handSelectorLabel: 'Quelle main souhaitez-vous analyser ?',
      rightHand: 'Main Droite',
      leftHand: 'Main Gauche',
      rightHandHint: 'Main droite, destin et présent',
      leftHandHint: 'Main gauche, potentiel inné',
      instructions: 'Photographiez la paume ouverte avec un bon éclairage et un fond clair.',
      handTypeLabel: '✦ Type de main',
      cameraBtn: 'Caméra / Galerie',
      noConsent: '↑ Acceptez les conditions ci-dessus pour activer l\'envoi de photo',
      newAnalysis: 'Nouvelle analyse',
      errorMsg: 'Nous n\'avons pas pu lire les lignes de cette image. Assurez-vous que la paume est bien visible et éclairée.',
      errorRetry: 'Essayer avec une autre photo',
      loading1: 'Analyse des lignes de la main...',
      loading2: 'Identification des monts...',
      loading3: 'Consultation des astres...',
      loading4: 'Préparation de votre lecture ✦',
    },
    startAstral: {
      tabTalentos: 'Talents', tabDesafios: 'Défis', tabAmbientes: 'Environnements',
      tabLideranca: 'Leadership', tabAreas: 'Domaines Professionnels', tabCaminhos: 'Chemins Difficiles', tabCiclos: 'Cycles',
      tabVocacional: 'Carte Vocationnelle', tabAtual: 'Carrière Actuelle', tabAlmejada: 'Poste Visé', tabTransicao: 'Transition',
    },
    readings: {
      title: 'Lectures',
      subtitle: 'Votre historique de consultations',
      emptyAll: 'Aucune lecture trouvée pour l\'instant.',
      emptyFilter: 'Aucune lecture de ce type pour l\'instant.',
      reading: 'Lecture',
    },
    notFound: {
      title: 'Page introuvable',
      body:  'Les astres n\'ont pas pu localiser cette page. Peut-être s\'est-elle perdue dans le cosmos.',
      back:  'Retour à l\'accueil',
    },
    servicos: {
      heroCtaStart:          'Commencer maintenant',
      heroCtaAccess:         'Accéder',
      heroBadgeFree:         'Disponible dans toutes les offres',
      heroBadgeMonthly:      'Disponible à partir du Forfait Mensuel',
      heroBadgeAnnual:       'Exclusif au Forfait Annuel',
      tierFree:              'Gratuit',
      tierMonthly:           'Mensuel',
      tierAnnual:            'Annuel',
      benefitsTitle:         'Ce que vous allez découvrir',
      forWhoTitle:           'Ce service est pour vous si...',
      previewTitle:          'Un aperçu de ce que vous allez recevoir',
      previewSubtitle:       'Exemple illustratif, votre analyse est toujours unique',
      previewUnlock:         '✦ Débloquez votre analyse complète',
      plansTitle:            'Choisissez votre forfait et commencez maintenant',
      plansRecommended:      '✦ RECOMMANDÉ POUR CE SERVICE',
      testimonialsTitle:     'Ce que disent nos utilisatrices',
      faqTitle:              'Questions fréquentes',
      finalCtaTitle:         'Commencez maintenant et recevez votre analyse en quelques instants',
      finalCtaAnonDesc:      'Il suffit d\'une minute pour créer votre compte et explorer l\'univers Professya.',
      finalCtaCreateAccount: 'Créer un compte gratuit',
      finalCtaHaveAccount:   'J\'ai déjà un compte',
      comingSoonBtn:         'Bientôt disponible ✦',
      comingSoonBadge:       'Lancement imminent',
      comingSoonDesc:        'Nous peaufinons les derniers détails. Vous pourrez bientôt accéder à ce service sur Professya.',
    },
    profile: {
      title:    'Mon Compte',
      subtitle: 'Gérez vos informations et votre sécurité.',
      planSection:  'Mon Abonnement',
      currentPlan:  'Abonnement actuel :',
      planFree:     'Gratuit',
      planMonthly:  'Mensuel',
      planAnnual:   'Annuel',
      planFreeFull:    'Gratuit',
      planMonthlyFull: 'Professya Mensuel',
      planAnnualFull:  'Professya Annuel',
      cancelCta:    'Résilier l\'abonnement',
      cancelPrompt: 'Vous nous manquerez. Si vous souhaitez nous donner la raison (optionnel) :',
      cancelReasonPricey:        'C\'est devenu trop cher',
      cancelReasonUnused:        'Je ne l\'utilise pas autant que prévu',
      cancelReasonPause:         'Je vais faire une pause et revenir',
      cancelReasonOtherPlatform: 'J\'ai trouvé une autre plateforme',
      cancelReasonMisc:          'Autre raison',
      cancelConfirmCta: 'Résilier mon abonnement',
      cancelling:       'Résiliation...',
      cancelError:      'Impossible de résilier. Réessayez ou contactez-nous.',
      cancelBack:       'Retour',
      accountSection:   'Informations du compte',
      nameLabel:        'Prénom :',
      emailLabel:       'E-mail :',
      planLabel:        'Abonnement :',
      birthSection:     'Données de naissance',
      birthEditBtn:     'Modifier',
      birthDateLabel:   'Date :',
      birthTimeLabel:   'Heure :',
      birthCityLabel:   'Ville :',
      birthTimeNotSet:  'Non renseignée',
      birthSaveSuccess: 'Données mises à jour. Recalcul de votre thème natal...',
      birthDateFormLabel: 'Date de naissance',
      birthTimeFormLabel: 'Heure de naissance (optionnelle)',
      birthCityFormLabel: 'Ville de naissance',
      birthCityPlaceholder: 'Ex : Paris',
      saveCta:      'Enregistrer',
      savingCta:    'Enregistrement...',
      cancelEditCta: 'Annuler',
      confirmTitle: 'Recalculer le thème natal ?',
      confirmDesc:  'Modifier votre date de naissance recalculera votre thème natal. Vos lectures précédentes ne seront pas affectées, mais les nouvelles utiliseront les données mises à jour.',
      confirmCta:   'Confirmer et recalculer',
      securitySection: 'Sécurité',
      genderLabel: 'Genre :', genderM: 'Masculin', genderF: 'Féminin', genderNB: 'Non-binaire', genderNotSay: 'Préfère ne pas préciser',
      birthLimitError: 'Vous avez atteint la limite de 2 modifications des données de naissance. Contactez le support pour demander une correction.',
    },
  },
  shared: {
    privacyTitle: 'Votre vie privée est une priorité',
    privacyDesc: 'La photo est traitée uniquement pour l\'analyse et n\'est jamais sauvegardée sur nos serveurs. Les données de géolocalisation (EXIF) sont supprimées avant l\'envoi.',
    privacyConsent: '✓ Compris, la photo ne sera pas sauvegardée. J\'accepte de continuer.',
    feedbackQuestion: 'Cette lecture vous a-t-elle été utile ?',
    feedbackThanks: 'Merci pour votre retour !',
    shareWhatsApp: 'Partager mon Secret Astral ✦',
    shareCopied: 'Texte copié ! Collez sur WhatsApp ✦',
    shareError: 'Impossible de partager. Essayez de copier le texte manuellement.',
    buyCredits: 'Acheter des crédits ✦',
    newConsult: 'Nouvelle consultation',
    retry: 'Réessayer',
  },
};

export default fr;
